export type ErrorType = {
  error?: string;
};

export function readError(e: unknown) {
  if (typeof e === "object" && e !== null && "error" in e) {
    return (e as { error: ErrorType }).error;
  } else {
    return "erreur.INCONNUE";
  }
}
